export default "/images/e68a1cc770cd799a322fc27cf9aabe2d.avif";